module.exports = __webpack_public_path__ + "img/park-outline-average-blue-grey.30f4c90a.svg";